<template>
    <div class="navigation-wrapper">
        <div class="links-container">
            <ul>
              <li :key="index"
                  v-for="(list, index) in unorderedList"
                  @click="handleAnchorClick(list.refName, list.id)">
                  {{list.name}} <fai v-if="list.id === activeListId" :icon="['fas', 'caret-left']" />
              </li>
            </ul>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'BrandsMarketplaceNavigation',

    props: {
      showStateNav: Boolean,
      showSponsoredNav: Boolean,
      showStoreNav: Boolean
    },

    data() {
      return {
        activeListId: null,
        unorderedList: [
          {
            name: 'by state',
            refName: 'top',
            id: 0
          },
          {
            name: 'previously sponsored',
            refName: 'sponsored',
            id: 1
          },
          {
            name: 'in-store',
            refName: 'inStore',
            id: 2
          }
        ]
      }
    },

    methods: {
      handleAnchorClick(ref, id) {
        this.activeListId = id
        this.$emit('scrollMeTo', ref)
      },
    },

    mounted() {
      if (!this.showStateNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 0)
      }

      if (!this.showSponsoredNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 1)
      }

      if (!this.showStoreNav) {
        this.unorderedList = this.unorderedList.filter(x => x.id !== 2)
      }
    }
  }

</script>

<style scoped>
  .links-container {
    color: #128ff9;
  }

  .links-container svg {
    font-size: 22px;
    border: 0;
    position: absolute;
    right: -10px;
    top: 3px;
  }

  .links-container  ul {
    list-style: none;
    margin-top: 20px;
    cursor: pointer;
    margin-bottom: 0;
    width: max-content;
    display: inline-flex;
  }

  .links-container li {
    font-size: 18px;
    font-family: 'AileronLight';
    margin-right: 40px;
    position: relative;
  }
</style>
